var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id)?_c('div',{staticClass:"twitter-feed"},[_c('Timeline',{attrs:{"id":_vm.id,"sourceType":'profile',"options":{ tweetLimit: '10' }}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }